"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
/**
 * Checkbox override.
 */
// tslint:disable-next-line:variable-name
var CheckBox = function (props) {
    var value = props.value, onChange = props.onChange, className = props.className, ownLabel = props.ownLabel, disabled = props.disabled;
    var outputClassName = classnames_1.default("respect__input_checkbox", className, value ? "checked" : "unchecked", disabled ? "disabled" : undefined);
    var ret = react_1.default.createElement("span", { className: outputClassName, onClick: disabled ? undefined : onChange });
    if (ownLabel) {
        ret = (react_1.default.createElement("span", { className: classnames_1.default("respect__input_checkbox_label", { disabled: disabled }) },
            ret,
            react_1.default.createElement("label", { onClick: disabled ? undefined : onChange }, ownLabel)));
    }
    return ret;
};
exports.default = CheckBox;
//# sourceMappingURL=CheckBox.js.map